const PERMISSION_KEY= "core:membership_plan";
const PAGE_URL = {
    MEMBERSHIP_PLAN_PAGE: "/admin/core/membership-plan"
}

export {PERMISSION_KEY, PAGE_URL}

